import amplitude from "amplitude-js"
import Bugsnag from "./bugsnag"

const eventContext = {};


export const Tracking = {
    /** sends error data to remote tracking tool. Console.error (err) */
    error: (err: Error | unknown) => {
        console.error(err)
        Bugsnag.notify(err as Error)
    },
    /** sends event to amplitude for tracking */
    action: (type: any, props: any = {}) => {
        // amplitude.getInstance().logEvent(type, { ...eventContext, ...props, host: location.host });

        if (window.ga) {
            window.ga(() => {
                window.ga.getAll().forEach((tracker: any) => {
                    tracker.set(props);
                    tracker.send('event', 'Vromo Event', type);
                });
            });
        }
    }
}